import { render } from "./CardsTitle.vue?vue&type=template&id=7214afb8&scoped=true"
import script from "./CardsTitle.vue?vue&type=script&lang=js"
export * from "./CardsTitle.vue?vue&type=script&lang=js"

import "./CardsTitle.vue?vue&type=style&index=0&id=7214afb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7214afb8"]])

export default __exports__